<template>
  <div class="travel-date-info">
    <div class="travel-date pf-medium">
      <div>{{ is602 ? '使用日期' : '游玩日期' }}</div>
      <div>{{ $$dateFormat(date, 'YY-MM-DD') }}</div>
    </div>
  </div>
</template>

<script>
import { SKUTAG } from '@/plugins/enum'

export default {
  props: {
    date: {
      type: Number,
      default: ''
    },
    is602: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.travel-date-info {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);

  .travel-date {
    padding: rem(32px) rem(24px) rem(30px) rem(24px);
    border-radius: rem(16px);
    background: #fff;
    font-size: rem(26px);
    color: #262626;
    line-height: rem(30px);
    margin-bottom: rem(20px);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
